import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'twinkle-button-link',
  templateUrl: './button-link.component.html',
  styleUrls: ['./button-link.component.scss']
})
export class ButtonLinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
